"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePayOutMethods = void 0;
var react_1 = require("react");
var keys_1 = require("../keys");
var useCache_1 = require("../useCache");
var useQuery_1 = require("../useQuery");
var country_1 = require("../country");
var user_1 = require("../user");
var CURRENT_COUNTRY = 'current_country';
var usePayOutMethods = function () {
    var country = (0, country_1.useProfileCountry)();
    var _a = (0, useCache_1.useCache)(), getDataFromCache = _a.getDataFromCache, setDataToCache = _a.setDataToCache;
    var isAuthorized = (0, user_1.useIsAuthorized)();
    var _b = (0, useQuery_1.useQuery)({
        canRender: !!country && isAuthorized,
        path: keys_1.PAY_OUT_METHODS,
        payload: {
            country: country,
        },
        shouldRetryOnError: false,
        revalidateOnMount: true,
    }), data = _b.data, error = _b.error, isLoading = _b.isLoading, mutate = _b.mutate;
    (0, react_1.useEffect)(function () {
        var prevCountry = getDataFromCache(CURRENT_COUNTRY);
        if (country && prevCountry !== country) {
            mutate();
            setDataToCache(CURRENT_COUNTRY, country);
        }
        else if (!prevCountry)
            setDataToCache(CURRENT_COUNTRY, country);
        if (!isAuthorized)
            setDataToCache(CURRENT_COUNTRY, null);
    }, [getDataFromCache, setDataToCache, country, mutate, isAuthorized]);
    return (0, react_1.useMemo)(function () { return ({
        data: data === null || data === void 0 ? void 0 : data.data,
        isLoading: isLoading,
        error: error,
        payOutMethods: mutate,
    }); }, [data, isLoading, error]);
};
exports.usePayOutMethods = usePayOutMethods;
